import React from "react";
import { Loader2 } from "lucide-react";
import { LANGUAGES, useTranslation } from "../context/TranslationContext";

export default function TranslationBanner() {
  const { translating, lang } = useTranslation();
  if (!translating || lang === "en") return null;
  const meta = LANGUAGES.find((l) => l.code === lang);
  const label = meta ? meta.label : lang.toUpperCase();
  return (
    <div
      data-testid="translation-banner"
      className="fixed top-4 left-1/2 -translate-x-1/2 z-[100] bg-navy text-pearl px-5 py-2.5 rounded-full shadow-lg flex items-center gap-3 text-sm border border-saffron/40"
      role="status"
      aria-live="polite"
    >
      <Loader2 size={16} className="animate-spin text-saffron" />
      <span className="tracking-wide">
        Translating to <span className="text-saffron font-medium">{label}</span>…
      </span>
    </div>
  );
}
